import React from "react";
import { FormGroup, Label, Input, Col, Row } from "reactstrap";
import Select from "react-select";

import { FormattedMessage, useIntl } from "react-intl";

export default function CreateNewLWModuleForm({
  setModule,
  module,
  errors,
  setErrors,
  lwFileNames,
}) {
  const intl = useIntl();
  const handleSetName = (name) => {
    setErrors(errors.filter((obj) => obj !== "name"));
    setModule({
      ...module,
      name: name,
    });
  };

  const handleSetLwGuid = (LwGuid) => {
    setErrors(errors.filter((obj) => obj !== "lwGuid"));
    setModule({
      ...module,
      lwGuid: LwGuid,
    });
  };

  const handleSetDescription = (description) => {
    setErrors(errors.filter((obj) => obj !== "description"));
    setModule({
      ...module,
      description: description,
    });
  };

  const handleSetUrl = (filename) => {
    setErrors(errors.filter((obj) => obj !== "url"));
    setModule({ ...module, url: filename });
  };

  const handleSetCode = (code) => {
    setErrors(errors.filter((obj) => obj !== "code"));
    setModule({
      ...module,
      code: code,
    });
  };

  return (
    <FormGroup>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="LWFile">LW-fil</Label>
        </Col>
        <Col>
          <Select
            placeholder={intl.formatMessage({ id: "LwFilename" })}
            className={errors.includes("url") ? "input--withWarning" : ""}
            onChange={(selected) => handleSetUrl(selected.value)}
            options={(lwFileNames.data || []).map((option) => ({
              ...option,
              label: option,
              value: option,
              clearableValue: true,
            }))}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="Answers">Facit-pdf</Label>
        </Col>
        <Col>
          <Input
            type="file"
            onChange={(e) =>
              setModule({ ...module, answers: e.target.files[0] })
            }
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="Name" style={{ marginTop: ".5rem" }}>
            <FormattedMessage id="Name" />
          </Label>
        </Col>
        <Col>
          <Input
            name="Name"
            type="text"
            className={errors.includes("name") ? "input--withWarning" : ""}
            value={module.name}
            onChange={(data) => handleSetName(data.target.value)}
          ></Input>
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="LwGuid" style={{ marginTop: ".5rem" }}>
            LWGuid
          </Label>
        </Col>
        <Col>
          <Input
            name="LwGuid"
            type="textarea"
            placeholder="ex. F7331DF2-03E4-4FB0-8700-196434482F0B"
            className={errors.includes("lwGuid") ? "input--withWarning" : ""}
            defaultValue={module.lwGuid}
            onChange={(data) => handleSetLwGuid(data.target.value)}
          ></Input>
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="Code" style={{ marginTop: ".5rem" }}>
            <FormattedMessage id="Code" />
          </Label>
        </Col>
        <Col>
          <Input
            name="Code"
            type="text"
            className={errors.includes("code") ? "input--withWarning" : ""}
            placeholder="ex. AAA"
            defaultValue={module.code}
            onChange={(data) => handleSetCode(data.target.value)}
          ></Input>
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="Description" style={{ marginTop: ".5rem" }}>
            <FormattedMessage id="Description" />
          </Label>
        </Col>
        <Col>
          <Input
            name="Description"
            type="textarea"
            className={
              errors.includes("description") ? "input--withWarning" : ""
            }
            defaultValue={module.description}
            onChange={(data) => handleSetDescription(data.target.value)}
          ></Input>
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="ApproveScoreLimit" style={{ marginTop: ".5rem" }}>
            <FormattedMessage id="ApproveScoreLimitInPercentage" />
          </Label>
        </Col>
        <Col>
          <Input
            name="ApproveScoreLimit"
            type="number"
            defaultValue={module.approveScoreLimit}
            onChange={(data) =>
              setModule({
                ...module,
                approveScoreLimit: data.target.value,
              })
            }
          ></Input>
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="MaxScore" style={{ marginTop: ".5rem" }}>
            <FormattedMessage id="MaxScore" />
          </Label>
        </Col>
        <Col>
          <Input
            name="MaxScore"
            type="number"
            defaultValue={module.maxScore}
            onChange={(data) =>
              setModule({
                ...module,
                maxScore: data.target.value,
              })
            }
          ></Input>
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="MaxActivityPoints" style={{ marginTop: ".5rem" }}>
            <FormattedMessage id="MaxActivityPoints" />
          </Label>
        </Col>
        <Col>
          <Input
            name="MaxActivityPoints"
            type="number"
            defaultValue={module.maxActivityPoints}
            onChange={(data) =>
              setModule({
                ...module,
                maxActivityPoints: data.target.value,
              })
            }
          ></Input>
        </Col>
      </Row>
      <Row style={{ marginTop: "1rem" }}>
        <Col lg="4">
          <Label for="IsFinalExam" style={{ marginTop: ".5rem" }}>
            <FormattedMessage id="IsFinalExam" />
          </Label>
        </Col>
        <Col>
          <Input
            style={{ marginLeft: "0", marginRight: "1rem" }}
            name="Name"
            type="checkbox"
            checked={module.isFinalExam}
            onChange={(data) =>
              setModule({ ...module, isFinalExam: data.target.checked })
            }
          ></Input>
        </Col>
      </Row>
    </FormGroup>
  );
}
